import addHeaderToRequestOptions from "../../utils/add-header-to-request-options";

const debugHeader = token => fetch => {
  if (!token) {
    return (...args) => fetch(...args);
  }
  return (url, opts = {}) =>
    fetch(url, addHeaderToRequestOptions(opts, { [token]: true }));
};

export default debugHeader(
  process.env.NODE_ENV === "production" ? "" : process.env.REACT_APP_DEBUG_TOKEN
);
